const translationKorean = {
  nav: {
    notice: '소식',
    worldview: '세계관',
    stella: '스텔라',
    media: '미디어',
    webtoon: '웹툰',
  },
  news: {
    title: '소식',
    newest: '최신',
    more: '더보기',
  },
  worldview: {
    title: '세계관',
  },
  stella: {
    title: '스텔라',
  },
  media: {
    title: '미디어'
  },
  stellaSection: {
    yato: {
      name: '야토',
      description1: '안녕하세요 야토에요',
      description2: '야토라구요', 
    },
    odanming: {
      name: '오단밍',
      description1: '사랑의 요정',
      description2: '오단밍입니다♡', 
    },
    hamkubby: {
      name: '햄쿠비',
      description1: '햄쿠비에요이~',
      description2: '에? 이거 진짜에요?', 
    },
    yune: {
      name: '아미하 유네',
      description1: '안녕하세요',
      description2: '제가 좋은 꿈을 드릴게요♪', 
    },
    dori: {
      name: '쇼코코 도리',
      description1: '행운을 증명하는',
      description2: '도리~등장', 
    },
    fuwa: {
      name: '하쿠텐 후와',
      description1: '제가 여러분들을',
      description2: '지켜줄게요', 
    },
    niu: {
      name: '니우 니우',
      description1: '저만큼',
      description2: '쿨한 사람이 있을까요?', 
    },
  }
};

export default translationKorean;
